import BaseComponent from '../../js/base-component';

export default class BlacklistComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.response = this.refs.response;
        this.responseData = this.refs.data;
        this.attacks = document.getElementById('spam-attacks-log-table');
        this.hint = this.refs.hint;
        this.hint2 = this.refs.hint2;
        this.loadcomments = document.getElementById('loadmore');

        this.spamactivity = document.getElementById('spam-activity-on-date');
        this.recordhistory = document.getElementById('record-history');
        this.bruteTbaleBody = document.getElementById('ip_history_list');


        this.onLoadMoreClick = this.onLoadMoreClick.bind(this);
    }

    static getRequiredRefs(){
        return ['response', 'data'];
    }

    init(){
        this.setYear();

        if(load_blacklist_table) {
            this.loadResponse();
        }

        if(this.attacks){
            this.loadTable();
        }

        if(this.loadcomments){
            this.loadcomments.addEventListener('click', this.onLoadMoreClick);
        }

        if(record_type == 'ip'){
            this.loadBruteTable();
        }

    }

    setYear(){
        let year = new Date().getFullYear();

        if (document.getElementById("year")) {
            document.getElementById("year").value = year;
        }

        if (document.cookie.indexOf("js_year") == -1) {
            let d = new Date();
            d.setTime(new Date().getTime() + 86400 * 1000);
            document.cookie = "js_year=" + year + "; path=/; expires=" + d.toUTCString();
        }
    }

    syntaxHighlight(json) {
        json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            let cls = 'number';
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = 'key';
                } else {
                    cls = 'string';
                }
            } else if (/true|false/.test(match)) {
                cls = 'boolean';
            } else if (/null/.test(match)) {
                cls = 'null';
            }
            return '<span class="' + cls + '">' + match + '</span>';
        });
    }

    async loadResponse(){
        const formPostData = new FormData();
        formPostData.append('action', 'get-api-response');
        formPostData.append('record', spam_check_record);

        const response = await fetch(url_lang_prefix + '/blacklists', {
          method: 'post',
          body: formPostData,
        });
        const apiData = await response.json();

        if (apiData?.error) {
          this.response.classList.add('hidden');
          return;
        }

        const domainsList = Object.values(apiData?.data || {})[0]?.domains_list ?? [];

        const tdHostedSites = document.getElementById('td_hosted_sites');
        if (tdHostedSites) {
            tdHostedSites.classList.add('hidden');
            const hostedSites = document.getElementById('hosted_sites');
            hostedSites.innerHTML = domainsList.length ? domainsList.join(', ') : 'None';
            hostedSites.classList.remove('hidden');
        }

        document.querySelectorAll('.hide_if_record_ok').forEach(element => {
            if (element.getAttribute('data-state') !== 'log_unavailable'
                && typeof apiData.error == 'undefined'
                && apiData.data
                && apiData.data[spam_check_record].in_antispam_previous
            ) {
                element.classList.remove('hidden');
            }
        });

        let dataJson = this.syntaxHighlight(JSON.stringify(apiData, undefined, 4));
        this.responseData.innerHTML = dataJson;

    }

    async loadTable(){
        try {
            const formPostData = new FormData();
            formPostData.append('action', 'get-sal');
            formPostData.append('ajax_record', spam_check_record);
            formPostData.append('type', record_type);
            formPostData.append('spam_active', record_found);

            let blackListResponse = await fetch(url_lang_prefix + '/blacklists', {method: "post", body: formPostData});
            const apiData = await blackListResponse.json();

            if (typeof apiData.error !== 'undefined') {
                document.querySelectorAll('.hide_if_record_ok').forEach(element => {
                    element.setAttribute('data-state', 'log_unavailable');
                    element.classList.add('hidden');
                });
            } else {
                if (typeof apiData.records !== 'undefined' && apiData.records) {
                    let row = `
                        <tr :CLASS:>
                            <td><span class="table__td--span">:INDEX:</span></td>
                            <td><span class="table__td--span">:DATE:</span></td>
                            <td><span class="table__td--span">:IP:</span></td>
                            <td><span class="table__td--span">:EMAIL:</span></td>
                            <td><span class="table__td--span">:NICKNAME:</span></td>
                            <td><span class="table__td--span">:AGENT:</span></td>
                        </tr>`;
                    apiData.records.forEach(function (item, i) {
                        document.getElementById('spam-attacks-log-table').querySelector('.table__body').insertAdjacentHTML('beforeend', row
                            .replace(':INDEX:', i + 1)
                            .replace(':CLASS:', i > 9 ? 'class="table__td--shrink"' : '')
                            .replace(':DATE:', item.datetime)
                            .replace(':IP:', item.country ? '<span class="flag ' + item.country.toLowerCase() + '"></span>&nbsp;:IP:' : ':IP:')
                            .replace(':IP:', item.sender_ip ? '<a href="' + url_lang_prefix + '/blacklists/' + item.sender_ip + '" title="' + item.sender_ip + '">' + item.sender_ip + '</a>' : '')
                            .replace(':EMAIL:', item.sender_email ? item.email_active ? '<a href="' + url_lang_prefix + '/blacklists/' + item.sender_email + '" title="' + item.sender_email + '">' + item.sender_email + '</a>' : item.sender_email : '')
                            .replace(':NICKNAME:', item.sender_nickname ? item.sender_nickname : '')
                            .replace(':AGENT:', item.agent ? item.engine ? '<svg class="cms-icon icon-' + item.engine.replace(/\d+/g, '') + '"><use xlink:href="/assets/img/icons.svg#icon-' + item.engine.replace(/\d+/g, '') + '"></use></svg>' + item.agent : item.agent : '-')
                        );
                    });

                    if (apiData.records.length > 10) {
                        let showMore = `<tr><td colspan="6" class="text--center table__td--show-more">
                                            <button id="loadmoretable" type="button" class="button--reset title-2 medium underline text--brand cursor--pointer show-more">Show <span class="table__show-more-text table__show-more-text--more">more</span><span class="table__show-more-text table__show-more-text--less">less</span></button>
                                        </td>
                                        </tr>`;
                        document.getElementById('spam-attacks-log-table').querySelector('.table__body').insertAdjacentHTML('afterend', showMore);
                        document.getElementById('loadmoretable').addEventListener('click', this.onLoadMoreTableClick);
                    }

                    this.attacks.querySelector('.table__tr-spinner').classList.add('hidden');

                    if (email_domain) {
                        this.hint.classList.remove('hidden');
                        this.hint2.classList.remove('hidden');
                    }

                } else {
                    document.getElementById('spam-attacks-log').classList.add('hidden');
                    document.getElementById('spam-attacks-log-link').classList.add('hidden');
                }
            }
        }
        catch (e) {
            this.attacks.getElementsByClassName("spinner__container")[0].innerHTML = "<span class='text--center display-block'>There is no information</span>";
        }
    }

    async onLoadMoreClick(e) {
        let comment_template = '<li class="comment__item" id="anc:review_revid:">' +
            '<span class="comment__userpic">L</span>' +
            '<div class="comment__info">' +
            '<h4 class="comment__header" id=":review_revid:"><span class="visually-hidden">By</span> <i class="comment__author">:review_nickname:</i>' +
            '<span class="visually-hidden">for :review_record:</span>' +
            '<span class="comment__decision :text-class:">:review_review:</span>' +
            '<span class="comment__date">:review_submitted:</span></h4>' +
            '<p id="revtext139" class="comment__text text">Spam as it is</p></div></li>';

        this.loadcomments.classList.add('button--loading');
        this.loadcomments.innerHTML += '<span class="spinner"></span>';
        let commentList = document.querySelectorAll('.comment__list>li');
        if (commentList && commentList.length > 0) {
            let get_last_post_display = commentList[commentList.length - 1].getAttribute('id').substr(3);

            const commentGet = await fetch('', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: `last_id_comment_bl=${get_last_post_display}`,
            });

            try {
                const data = await commentGet.json();

                if (data) {
                    if (Object.keys(data.rows).length != 0) {
                        for (let row in data.rows) {
                            const li = document.createElement('li');
                            li.setAttribute('id', `anc${data.rows[row].revid}`);
                            li.setAttribute('class', `comment__item`);
                            li.innerHTML = comment_template
                                .replaceAll(':review_nickname:', data.rows[row].nickname)
                                .replace(':review_review:', data.rows[row].review)
                                .replace(':review_gaimg:', data.rows[row].gaimg)
                                .replace(':review_record:', review_record_ip)
                                .replace(':review_submitted:', data.rows[row].submitted)
                                .replaceAll(':review_revid:', data.rows[row].revid)
                                .replace(':text-class:', data.rows[row].vote == '1' ? 'text--danger' : 'text-success')
                                .replace(':review_vote:', data.rows[row].vote == '1' ? 'SPAM' : 'NOT SPAM')
                            commentList[commentList.length - 1].after(li);
                        }
                        this.loadcomments.classList.remove('button--loading');
                        this.loadcomments.innerHTML= 'Click to view other comments';
                    } else {
                        this.loadcomments.innerHTML= 'No more comments';
                        this.loadcomments.setAttribute("disabled", 'disabled');
                    }
                }
            } catch (e) {
                this.loadcomments.setAttribute("disabled", 'disabled');
            }

        }
    }

    onLoadMoreTableClick(e){
        document.getElementById('spam-attacks-log-table').classList.toggle('is-expanded');
    }

    async loadBruteTable(e){
        const formPostData = new FormData();
        formPostData.append('action', 'get-saod');
        formPostData.append('record', spam_check_record);

        const getSaod = await fetch(url_lang_prefix + '/blacklists', {method: "post", body: formPostData});

        const data = await getSaod.json();

        try {
            if (data) {
                let row = '<tr><td>:ROW:</td><td>:DATE:</td><td>:IP:</td><td>:FREQUENCY:</td></tr>';
                document.getElementById('preloader-box').classList.add('hidden');

                if(typeof data.error !== 'undefined'){
                    this.spamactivity.classList.add('hidden');
                    this.recordhistory.classList.add('hidden');
                }else{
                    if(typeof data.ip_history_list !== 'undefined') {
                        this.spamactivity.classList.remove('hidden');
                        this.recordhistory.classList.remove('hidden');

                        data.ip_history_list.forEach((item,i)=> {
                            this.bruteTbaleBody.insertAdjacentHTML('beforeend',
                                row
                                    .replace(':ROW:', i + 1)
                                    .replace(':DATE:', item.date)
                                    .replace(':IP:', item.ip_str)
                                    .replace(':FREQUENCY:', item.frequency)
                            );
                        });
                    }
                }
            }
        } catch (e) {
            console.log('error')
        }

    }

    onDestroy(){
        if(this.loadcomments){
            this.loadcomments.removeEventListener('click', this.onLoadMoreClick);
        }
    }
}
